/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Metadata_Scan_NoInputs */

const en_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_player_metadata_scan_no = /** @type {(inputs: Player_Metadata_Scan_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Player_Metadata_Scan_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_metadata_scan_no = /** @type {((inputs?: Player_Metadata_Scan_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Metadata_Scan_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_metadata_scan_no(inputs)
	if (locale === "de") return de_player_metadata_scan_no(inputs)
	if (locale === "it") return it_player_metadata_scan_no(inputs)
	if (locale === "ru") return ru_player_metadata_scan_no(inputs)
	if (locale === "es") return es_player_metadata_scan_no(inputs)
	if (locale === "zh-CN") return zh_cn2_player_metadata_scan_no(inputs)
	if (locale === "ja") return ja_player_metadata_scan_no(inputs)
	if (locale === "hi") return hi_player_metadata_scan_no(inputs)
	if (locale === "pt-PT") return pt_pt2_player_metadata_scan_no(inputs)
	return en_player_metadata_scan_no(inputs)
});